// extracted by mini-css-extract-plugin
export default {"li":"CategoryItem_li__5sBJ9","active":"CategoryItem_active__oOfF3","button":"CategoryItem_button__2jqrg","textIcon":"CategoryItem_textIcon__bOUTU"};